import axios from "axios";
import { useMutation } from "react-query";
import { ICreateWorkHistory } from "../types";
import { END_POINT } from "config/environment";

export const createWorkHistory = async (props: ICreateWorkHistory) => {
  const url = `${END_POINT.BASE_URL}/v1/save-work-history`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const data: any = {
    id: props.id,
    talent_id: props.talent_id,
    title: props.title,
    sector_id: props.sector_id,
    company: props.company,
    work_type: props.work_type,
    start_date: props.start_date,
    end_date: props.end_date,
    is_current: props.is_current,
    description: props.description,
    achievements: props.achievements,
  };

  const response = await axios.post(url, data, config);
  return response;
};

export const useCreateWorkHistory = () => {
  return useMutation(createWorkHistory);
};
